import { channelApi } from './channelApi';

export interface InAppMessagePrimary {
  text: string;
  textColor: string;
  bgColor: string;
  action: string;
}

export interface InAppMessageContent {
  id: number;
  title: string;
  intro: string;
  bgColor: string;
  textColor: string;
  primary: InAppMessagePrimary;
}

export interface InAppActiveMessage extends InAppMessageContent {
  image: {
    url: string;
    width: number;
    height: number;
  } | null;
  created: string;
  delivery: string;
  expire: string;
}

interface InAppMessageResult {
  activeMessage: InAppActiveMessage | null;
}

interface InAppMessageReceivedArgs {
  messageId: number;
}

export const inAppMessageApi = channelApi.injectEndpoints({
  endpoints: (builder) => ({
    getInAppMessage: builder.query<InAppMessageResult, void>({
      query: () => ({
        url: '/webapp/in-app-messages',
      }),
    }),
    InAppMessageReceived: builder.mutation<void, InAppMessageReceivedArgs>({
      query: ({ messageId }) => ({
        url: `/webapp/in-app-messages/${messageId}`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useGetInAppMessageQuery, useInAppMessageReceivedMutation } = inAppMessageApi;
